<template>
    <div>
        <h4 v-if="title">{{ title }}</h4>
        <h4 v-if="subTitle" id="sub-title">{{ subTitle }}</h4>
        <el-table
                v-if="isTable"
                id="report-table"
                size="mini"
                :data="table"
                empty-text="No parameters calculated"
                stripe>
            <el-table-column
                    label="Parameter"
                    prop="parameter"
                    align="left"
                    width="260"
            >
            </el-table-column>
            <el-table-column
                    v-if="includeSymbol"
                    class-name="symbol-col"
                    label="Symbol"
                    prop="symbol"
                    align="center"
                    width="75"
            >
            </el-table-column>
            <el-table-column
                    label="Value"
                    prop="value"
                    :align="alignValue"
                    :width="widthValue"
                    class-name="value-column"
            >
                <template slot-scope="scope">
                    <el-link v-if="scope.row.href" :href="scope.row.href" type="primary" class="font-inherit">
                        {{ scope.row.value }}
                    </el-link>
                    <span v-else>{{scope.row.value}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    v-if="includeUnits"
                    label="Units"
                    prop="units"
                    align="left"
                    width="55"
            >
            </el-table-column>
        </el-table>
        <div slot="empty" v-else-if="$slots.empty">
            <slot name="empty"/>
        </div>
        <span v-else>
            <b style="color: darkorange;">WARNING: </b>
            <span style="color: var(--color)">Cannot calculate data.  Review model.</span>
        </span>
    </div>
</template>

<script>
  export default {
    name: "ReportTableParams",
    props: {
      title: String,
      subTitle: String,
      table: Array,
    },

    computed: {
      isTable() {
        return !!this.table && this.table.length !== 0;
      },
      includeSymbol() {
        return this.isTable && typeof this.table[0].symbol !== 'undefined';
      },
      includeUnits() {
        return this.isTable && typeof this.table[0].units !== 'undefined';
      },
      widthValue() {
        // Calculate width of value column to keep table width the same regardless of excluded columns.
        let width = 180;  // all values except Assembly table could use 75
        if (!this.includeSymbol) width += 75;
        if (!this.includeUnits) width += 55;
        return width;
      },
      alignValue() {
        return this.includeUnits ? 'right' : 'left';
      },
    },
  }
</script>

<style scoped lang="scss" src="../../assets/css/table.scss"/>
<style scoped lang="scss">
    $margin: 1em;
    #sub-title {
        margin-left: $margin;
        color: var(--color-secondary);
    }
    #report-table {
        margin-left: $margin;
        /*width: max-content;*/
        /*margin-right causes table to continuously expand*/
        /*width: calc(100% - 2 * #{$margin});*/
    }
    .font-inherit {
        font-size: inherit;
    }

    /* TRIED BUT COULD NOT ACHIEVE DESIRED RESULT */
    /* https://github.com/ElemeFE/element/issues/7317 */
    /*/deep/ td.value-column .cell {*/
        /*background: darkcyan;*/
        /*min-width: max-content;*/
    /*}*/

    /* TRIED BUT COULD NOT GET SMALLER MathJax COLUMN */
    /*/deep/ td.symbol-col {*/
        /*font-size: .7em;*/
        /*!*font-size: 5pt !important;*!*/
        /*!*font-size: 10pt;*!*/
        /*!*transform: scale(.5);*!*/
        /*color: red;*/
    /*}*/
</style>
